import { TRASHIE_GOOGLE_MAPS_API_KEY } from '../config/config';

const script = `https://maps.googleapis.com/maps/api/js?key=${TRASHIE_GOOGLE_MAPS_API_KEY}&libraries=places`;

export default script;
